import http from '../../../http-common';

export function requestLoadControlIngresos() {
    return http.get('/control-ingresos');
}

export function requestSaveControlIngreso(ingreso) {
    if (ingreso.id && ingreso.id !== 0) {
        return http.put(`/control-ingresos/${ingreso.id}`, ingreso);
    }
    return http.post('/control-ingresos', ingreso);
}
